import { createSalesTransPrice, getSalesTransPrice, deleteTransCost } from '@/api/salesTransCostRecord'
import Vue from 'vue'

import caclSalesCost from './caclSalesCost'


const state = {
  salesTransCostRecordList: [],
  totalCounts: 0,
}

const actions = {

  async getSalesTransPriceAction({ commit }, payload) {
    try {
      const res = await getSalesTransPrice(payload)
      commit('SET_SALES_PRICE_RECORD', res.data)
      return res.data.salesTransCostRecordList
    } catch (error) {
      throw error
    }
  },

  async createSalesTransPriceAction({ commit }, payload) {
    try {
      const newSalesTransPrice = await createSalesTransPrice(payload.form)
      newSalesTransPrice.data.rePrice = payload.form.cost
      newSalesTransPrice.data.cost = payload.form.cost
      newSalesTransPrice.data.reSales = payload.form.sales
      newSalesTransPrice.data.startActiveDate = payload.form.startActiveDate
      commit('CREATE_SALES_PRICE_RECORD', newSalesTransPrice.data)
      return newSalesTransPrice.data
    } catch (error) {
      throw error
    }
  },

  async deleteTransCostAction({ commit }, payload) {
    try {
      await deleteTransCost(payload.id)
      commit('DELETE_TRANS_COST', payload.id)
      return payload.id
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  SET_SALES_PRICE_RECORD(state, payload) {
    state.salesTransCostRecordList = payload.salesTransCostRecordList
    state.totalCounts = payload.totalCounts
  },

  CREATE_SALES_PRICE_RECORD(state, payload) {
    if (payload.reCalcSalesCost) {
      payload.sales.cost = payload.sales.transCost.cost
      state.salesTransCostRecordList.unshift(payload.sales)
      state.totalCounts++
      Vue.set(caclSalesCost.state.salesLatestCost, caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.sales._id), payload.sales)
    } else {
      state.salesTransCostRecordList.unshift(payload)
      state.totalCounts++
      const index = caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.reSales)
      const sales = caclSalesCost.state.salesLatestCost[index]
      sales.transCost = { cost: payload.rePrice }
      Vue.set(caclSalesCost.state.salesLatestCost, index, sales)
    }
  },
  DELETE_TRANS_COST(state, id) { 
    state.salesTransCostRecordList = state.salesTransCostRecordList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}